import getBasePath from '../../produto/common/functions/api-resource';

export const NOME_CONDICAO_PO_EVIDENCIA = 'REGISTRAR_PO_E_EVIDENCIA_NA_APROVACAO';

const FORM_IND_EVIDENCIA_PO_APROVACAO = 'ind_evidencia_po_aprovacao';

export function nomeCondicionalPassoAtual(res) {
  const nome = res && res.data && res.data.nome_condicional;
  return nome == null ? '' : String(nome).trim();
}

function enviarEvidenciasPo(http, idAcao, arquivos) {
  if (!arquivos || !arquivos.length) {
    return Promise.resolve();
  }
  const url = `${getBasePath('job', 'arquivo/acao')}/${idAcao}/upload`;
  return arquivos.reduce((cadeia, arquivo) => cadeia.then(() => {
    const form = new FormData();
    form.append('file', arquivo);
    form.append('descricao', arquivo.name);
    form.append('filename', encodeURI(arquivo.name));
    form.append(FORM_IND_EVIDENCIA_PO_APROVACAO, 'true');
    return http.post(url, form);
  }), Promise.resolve());
}

export function gravarPoEvidencia(recurso, http, idAcao, extra, exigePoEvidencia, mensagemObrigatorio) {
  if (!exigePoEvidencia) {
    return Promise.resolve();
  }
  if (!extra || !extra.numeroPedidoCompra || !extra.arquivosEvidencia || !extra.arquivosEvidencia.length) {
    return Promise.reject(mensagemObrigatorio);
  }
  return recurso.atualizarDesAtributos({
    id: idAcao,
    desAtributos: { num_pedido_compra: extra.numeroPedidoCompra },
  }).then(() => enviarEvidenciasPo(http, idAcao, extra.arquivosEvidencia));
}

export default {
  data() {
    return {
      exigePoEvidencia: false,
    };
  },
  watch: {
    idAcao() {
      this.carregarExigePoEvidencia();
    },
    status() {
      this.carregarExigePoEvidencia();
    },
  },
  methods: {
    carregarExigePoEvidencia() {
      this.exigePoEvidencia = false;
      if (!this.idAcao || this.status !== 'AGUARDANDO_APROVACAO') {
        return;
      }
      this.buscarExigePoEvidencia()
        .catch(() => {
          this.exigePoEvidencia = false;
        });
    },
    buscarExigePoEvidencia() {
      return this.workflowAcaoResource
        .buscarCondicionalPassoAtual({ idAcao: this.idAcao })
        .then((res) => {
          this.exigePoEvidencia = nomeCondicionalPassoAtual(res) === NOME_CONDICAO_PO_EVIDENCIA;
        });
    },
    aprovar(justificativa, irProximo, valoresMetadados, dtaProrrogacao, extra) {
      const { idAcao } = this;
      this.buscarExigePoEvidencia()
        .then(() => gravarPoEvidencia(
          this.apuracaoAcaoResource,
          this.$http,
          idAcao,
          extra,
          this.exigePoEvidencia,
          this.$t('message.campo_obrigatorio'),
        ))
        .then(() => this.atualizarMetadadosAprovacao(valoresMetadados))
        .then(() => this.workflowAcaoResource.aprovarPasso({ idAcao }, { observacao: justificativa }))
        .then(() => {
          this.$emit('recarregar');
          this.$toast(this.$t('message.acao_aprovada'));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    atualizarMetadadosAprovacao(valoresMetadados) {
      if (!valoresMetadados || !this.idAcao) {
        return Promise.resolve();
      }
      return this.apuracaoAcaoResource.atualizarDesAtributos({
        id: this.idAcao,
        desAtributos: valoresMetadados,
      });
    },
  },
  mounted() {
    this.carregarExigePoEvidencia();
  },
};
